import { NgClass } from '@angular/common';
import { Router } from '@angular/router';
import { Component, inject, input, InputSignal } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

import { NgGencatVerticalMenuItem } from '@shared/models/app-config.model';
import { RolePermissionDirective } from '@shared/directives/role-permission.directive';
import { FeatureFlagsDirective } from '@shared/directives/feature-flags.directive';

@Component({
  selector: 'li[app-sidebar-tree]',
  standalone: true,
  imports: [
    NgClass,
    TranslatePipe,
    RolePermissionDirective,
    FeatureFlagsDirective,
  ],
  template: `
    <div
      [ngClass]="{
        'sidebar-item': true,
        'sidebar-item-disabled': sidebarNode().isDisabled,
        'has-children': sidebarNode().isDropdown,
        'menu-item-active': sidebarNode().isActive,
        'sidebar-item-open': sidebarNode().isOpen,
      }"
    >
      <div
        class="sidebar-item-text-container"
        (click)="navigateSidebarToSite(sidebarNode())"
      >
        @if (sidebarNode().icon) {
          <i [class]="sidebarNode().icon"></i>
        }
        <span
          class="sidebar-item-text"
          [ngClass]="{ 'sidebar-item-text-weight': level() === 1 }"
        >
          {{ sidebarNode().text | translate }}
        </span>
      </div>

      @if (sidebarNode().isDropdown) {
        <i
          class="bi bi-chevron-down sidebar-item-arrow"
          [ngClass]="{ rotated: sidebarNode().isOpen }"
          (click)="toggleSidebarItem(sidebarNode())"
        ></i>
      }
    </div>

    @if (
      sidebarNode().isDropdown && !isSidebarCollapsed() && sidebarNode().isOpen
    ) {
      <ul [class]="'sidebar-submenu sidebar-level-' + level()">
        @for (child of sidebarNode().dropdownContent; track $index) {
          <ng-container *rolePermissions="child.roles">
            <ng-container *featureFlags="child.features">
              <li
                app-sidebar-tree
                class="sidebar-menu-item"
                [level]="level() + 1"
                [sidebarNode]="child"
                [isSidebarCollapsed]="isSidebarCollapsed()"
              ></li>
            </ng-container>
          </ng-container>
        }
      </ul>
    }
  `,
  styleUrls: ['./sidebar-tree.component.scss'],
})
export class SidebarTreeComponent {
  sidebarNode: InputSignal<NgGencatVerticalMenuItem> =
    input<NgGencatVerticalMenuItem>({} as NgGencatVerticalMenuItem);

  isSidebarCollapsed: InputSignal<boolean> = input<boolean>(false);

  level: InputSignal<number> = input<number>(1);

  private readonly _router = inject(Router);

  navigateSidebarToSite({ href }: NgGencatVerticalMenuItem): void {
    this._router.navigateByUrl(href);
  }

  toggleSidebarItem(item: NgGencatVerticalMenuItem): void {
    if (!this.isSidebarCollapsed() && item.isDropdown) {
      item.isOpen = !item.isOpen;
    }
  }
}
